import styles from './style.postcss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { PageCard, Grid, testClass } from 'omni-common-ui';
import classnames from 'classnames';

import ExpansionButton from 'components/ExpansionButton';
import { MERGED_SPEAKING_NAME } from 'data/IndividualDevelopmentPlans/skillScoreHFv4';
import ReadOnlyField from '../ReadOnlyField';
import { getAverageScoreHeading } from '../../unitRange';

const BOOKWORK = 'Bookwork';
const ONLINE = 'Online';
const ATTENDANCE = 'Attendance';
const TOTAL_SCORE = 'Total Score';
const COLUMNS_PER_ROW = 4;
const SKILL_DISPLAY_ORDER = [
  'Vocabulary',
  'Grammar',
  'Phonics',
  'Reading',
  'Listening',
  'Writing',
  'Speaking',
  MERGED_SPEAKING_NAME,
  'Speaking 1',
  'Speaking 2',
];

class ReportCard extends Component {
  render() {
    const {
      isExpanded,
      reportCardInfo,
      onExpandButtonClick,
      courseTypeLevelCode,
      reportName,
    } = this.props;
    let reportCardInfoDisplayItems = [];
    prepareReportCardInfoDisplayItems.call(this);
    const averageScoreHeading = getAverageScoreHeading(courseTypeLevelCode, reportName);

    return <PageCard className={classnames(styles.ReportCard_container, testClass('report-card'))}>
      <PageCard.Heading className={styles.ReportCard_heading}>
        <span>Report card</span>
        <span>{averageScoreHeading}</span>
      </PageCard.Heading>
      <PageCard.Content className={styles.ReportCard_content}>
        <Grid className={styles.ReportCard_grid}>
          {renderTotalScoreRow()}
          <Grid.Group>
            {renderGridItems()}
          </Grid.Group>
        </Grid>
      </PageCard.Content>
      {renderExpansionButton()}
    </PageCard>;

    function renderTotalScoreRow() {
      return <Grid.Group className={styles.ReportCard_totalScoreRow}>
        <Grid.Item xs={12}
            sm={3}
            md={3}
            className={styles.ReportCard_item}>
          <ReadOnlyField boardTitle={TOTAL_SCORE}
              boardValue={reportCardInfo.totalScore}
              hideDivider />
        </Grid.Item>
      </Grid.Group>;
    }

    function renderGridItems() {
      return reportCardInfoDisplayItems.map((source) => {
        const size = { xs: 12, sm: 3, md: 3 };
        return <Grid.Item key={source.title}
            xs={size.xs}
            sm={size.sm}
            md={size.md}
            className={styles.ReportCard_item}>
          <ReadOnlyField boardTitle={source.title}
              boardValue={source.value}
              className={source.className}
              hideDivider />
        </Grid.Item>;
      });
    }

    function prepareReportCardInfoDisplayItems() {
      reportCardInfo.skillResults.forEach(({ name, score }) => {
        reportCardInfoDisplayItems.push({
          title: name,
          value: score,
        });
      });

      if (reportCardInfo.homeworkCompletion) {
        reportCardInfoDisplayItems.push({
          title: BOOKWORK,
          value: reportCardInfo.homeworkCompletion,
        });
      }
      if (this.props.shouldShowOnline) {
        reportCardInfoDisplayItems.push({
          title: ONLINE,
          value: reportCardInfo.online,
        });
      }
      this.props.shouldShowAttendance && reportCardInfoDisplayItems.push({
        title: ATTENDANCE,
        value: reportCardInfo.attendance,
      });

      reportCardInfoDisplayItems = sortByDisplayOrder(reportCardInfoDisplayItems);
      reportCardInfoDisplayItems = hideReportCardItemsIfNeeded(reportCardInfoDisplayItems);
    }

    function sortByDisplayOrder(items) {
      if (! items || ! items.length) return items;

      const getSortIndex = (title) => {
        const index = SKILL_DISPLAY_ORDER.indexOf(title);
        return index === -1 ? SKILL_DISPLAY_ORDER.length : index;
      };

      return [...items].sort((a, b) => getSortIndex(a.title) - getSortIndex(b.title));
    }

    function hideReportCardItemsIfNeeded(items) {
      if (isExpanded || ! items || ! items.length > 0) return items;
      return items.slice(0, COLUMNS_PER_ROW);
    }

    function renderExpansionButton() {
      return <ExpansionButton isExpand={isExpanded}
          onExpansionButtonClick={() => onExpandButtonClick()} />;
    }
  }
}

ReportCard.propTypes = {
  reportCardInfo: PropTypes.object.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onExpandButtonClick: PropTypes.func.isRequired,
  shouldShowAttendance: PropTypes.bool.isRequired,
  shouldShowOnline: PropTypes.bool,
  courseTypeLevelCode: PropTypes.string,
  reportName: PropTypes.string,
};

ReportCard.defaultProps = {
  shouldShowOnline: false,
};

export default ReportCard;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/ReportCard/index.jsx